/**
 * Helpers for editing a StoryElement's `visual_description` JSON as flat
 * string fields. Shared by the cast editor surfaces (Define + Illustrate).
 *
 * `flattenVisual` turns the stored object (which may hold arrays, e.g.
 * `distinguishing_features`) into a `Record<string, string>` suitable for
 * text inputs. `unFlattenVisual` reverses it, dropping empty fields and
 * splitting comma lists back into arrays for the known list-valued keys.
 */
export function flattenVisual(obj: Record<string, unknown>): Record<string, string> {
  const flat: Record<string, string> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (Array.isArray(v)) flat[k] = v.join(', ');
    else if (typeof v === 'string') flat[k] = v;
    else if (v != null) flat[k] = String(v);
  }
  return flat;
}

export function unFlattenVisual(flat: Record<string, string>): Record<string, unknown> {
  const obj: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(flat)) {
    if (!v.trim()) continue;
    if (k === 'distinguishing_features') {
      obj[k] = v.split(',').map((s) => s.trim()).filter(Boolean);
    } else {
      obj[k] = v;
    }
  }
  return obj;
}
